import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import AdminRoutes from './screens/admin/AdminRoutes';
import LoginScreen from './screens/LoginScreen';
import { hydraterTaxonomie } from './config/shared_config';

function ProtectedRoutes() {
  const { user, isAdmin, checking } = useAuth();

  // Le référentiel de taxonomie est chargé UNE FOIS, après l'authentification
  // (l'endpoint la requiert) et AVANT le rendu des écrans : ceux-ci lisent la
  // taxonomie de façon synchrone en plein rendu, et hydrater après coup les
  // laisserait afficher les libellés de la copie embarquée jusqu'au prochain
  // re-render — silencieusement.
  // Cf. Documentation/IMPLEMENTATION/CARTOGRAPHIE_IMPACT_ID_COMPETENCES.md (P3).
  const [taxonomiePrete, setTaxonomiePrete] = React.useState(false);

  React.useEffect(() => {
    if (!user || !isAdmin) return;
    let annule = false;

    hydraterTaxonomie()
      .then(({ source, version }) => {
        if (source !== 'backend') {
          console.warn(`[taxonomy] Référentiel servi depuis « ${source} » (v${version ?? '?'}).`);
        }
      })
      .finally(() => {
        // Même en cas d'échec on affiche l'admin : le repli embarqué est exact
        // (parité vérifiée par test côté backend). Bloquer serait pire.
        if (!annule) setTaxonomiePrete(true);
      });

    return () => {
      annule = true;
    };
  }, [user, isAdmin]);

  if (checking) {
    return <div>Vérification des droits d'administration...</div>;
  }

  if (!user || !isAdmin) {
    return <Navigate to="/login" replace />;
  }

  if (!taxonomiePrete) {
    return <div>Chargement du référentiel de compétences…</div>;
  }

  return <AdminRoutes />;
}

function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/login" element={<LoginScreen />} />
        <Route path="/admin/*" element={<ProtectedRoutes />} />
        <Route path="/" element={<Navigate to="/admin" replace />} />
      </Routes>
    </AuthProvider>
  );
}

export default App;
